// src/pages/Returns.jsx — v5
// Added shipping-cost disclosure: original delivery shipping is
// non-refundable; return pickup (for approved returns) is arranged at
// nobrand store's cost, not the customer's.
import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import BottomNav from '../components/BottomNav';
export default function Returns() {
  const sections = [
    {
      title: 'Eligibility',
      content: (
        <>
          Returns are accepted only if you received a completely different size or color than what you ordered, or if the item arrived damaged. Specifically:
          <br /><br />
          <strong>Eligible:</strong> Wrong Size Received (e.g. you ordered size 24, received size 26), Wrong Color Received (e.g. you ordered black, received blue), Damaged Item Received.
          <br /><br />
          <strong>Not eligible:</strong> Size Issue (you received the size you ordered, it just doesn't fit or suit you), Color Issue (you received the color you ordered, it just looks different from the photo), or change of mind.
        </>
      )
    },
    {
      title: 'Colors May Vary',
      content: 'Product colors may appear slightly different from the images shown due to lighting and screen settings. Please check size charts carefully before ordering. This is not grounds for a return unless a completely different color was delivered.'
    },
    {
      title: 'Unboxing Video — Mandatory',
      content: 'A clear, uncut, unboxing video showing the issue is mandatory for any eligible return request. Requests submitted without a valid video will not be actioned or responded to.'
    },
    {
      title: 'Return Window',
      content: 'Returns must be initiated within 24 hours of confirming delivery in your Order History. No return requests will be accepted after this window closes.'
    },
    {
      title: 'Product Condition',
      content: 'Products must be unused, in original packaging with all contents intact. Used or altered items will not be accepted for return.'
    },
    {
      title: 'How to Initiate a Return',
      content: "Go to your Order History and tap 'Parcel Delivered' once your order arrives. If there's an eligible issue, tap 'Initiate Return' within 24 hours, select the reason, and upload your unboxing video using the link provided. For anything not covered by these categories, message us directly on WhatsApp."
    },
    {
      title: 'Return Shipping — At Our Cost',
      content: "Shipping charges paid at the time of your order are non-refundable. If your return is approved, we will contact you on WhatsApp to arrange pickup of the item at a convenient date — this pickup is arranged and paid for by us. You will not be asked to pay for return shipping. Please keep the item packed and ready for pickup once your return is approved."
    },
    {
      title: 'Resolution — Refund or nb wallet',
      content: "Once your return is approved and the item is received back with us, you'll be able to choose between a refund to your original payment method (2–3 days) or instant nb wallet credit. nb wallet credit is valid for 180 days from the date it's added, and can be used on any order (once your balance exceeds ₹25) up to 50% of that order's value. nb wallet credit cannot be transferred back to your bank account once added."
    },
    {
      title: 'Out-of-Stock Orders',
      content: "If an item you ordered turns out to be unavailable, we'll mark it Out of Stock and you'll get the same Refund or nb wallet choice immediately — no return steps needed."
    },
    {
      title: 'Return Transit',
      content: 'Once your parcel has been handed over for pickup, nobrand store takes responsibility for it. Please ensure it is securely packed before pickup.'
    },
    {
      title: 'Cancellations',
      content: 'Orders cannot be cancelled once payment is completed. There is zero refund or nb wallet credit for cancelled orders.'
    },
    {
      title: 'Need Help?',
      content: (
        <>
          For anything not covered above, message us on WhatsApp or visit our{' '}
          <Link to="/contact" style={{ color: '#2F6FED', fontWeight: 600, textDecoration: 'underline' }}>Contact page</Link>.
        </>
      )
    },
  ];
  return (
    <div className="app-shell">
      <Navbar showBack title="Return Policy" />
      <div className="page-body" style={{ paddingBottom: 80 }}>
        <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 6, color: 'var(--navy)' }}>Return Policy</h1>
        <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 24 }}>Last updated: July 2026</p>
        {sections.map((s, i) => (
          <div key={i} style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--navy)', marginBottom: 6, letterSpacing: '0.02em' }}>{s.title}</div>
            <p style={{ fontSize: 13, lineHeight: 1.8, color: '#555' }}>{s.content}</p>
          </div>
        ))}
      </div>
      <BottomNav />
    </div>
  );
}